import React, { useMemo } from 'react';
import { Home } from 'lucide-react';
import { useProperties } from '../hooks/useProperties';
import { PropertyCategoryView } from '../components/properties/PropertyCategoryView';
import { Counter } from '../components/ui/Counter';

export const ForRentList: React.FC = () => {
  const { properties, isLoading } = useProperties();

  const forRentProperties = useMemo(
    () => properties.filter(p => p.status === 'for-rent'),
    [properties]
  );

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4 py-4">
        <div className="mb-6 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-3">
              <Home className="h-8 w-8 text-primary-500" />
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                Biens en location
              </h1>
            </div>
            <Counter 
              count={forRentProperties.length} 
              label={forRentProperties.length > 1 ? "biens" : "bien"}
              variant="success"
            />
          </div>
        </div>
        <PropertyCategoryView
          title=""
          properties={forRentProperties}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};